// import { useAuth } from '@hooks/useAuth';
import { getPublicationsByState, getPostulationsByPublication, getPostulatedsAll, getPublication, setStatusPublication, storePublication, setConfirmPay, getLocationsAccount } from "services/Publications";
import { useCallback, useState } from "react";
import { getDataPostulatedsCount } from "services/Publications";


const usePublications = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [response, setResponse] = useState([])
    const [error, setError] = useState(null)


    // Ok
    const fetchData = useCallback(async (id = null, payload = {}, withReturn = false) => {
        setError(null)
        setIsLoading(true)

        try {
            let data;

            if (id) {
                data = await getPublication(id)
                setIsLoading(false)
            } else {
                data = await getPublicationsByState(payload)
            }

            if (withReturn) {
                setResponse(data.data)
                setIsLoading(false)
                return id ? data : data
            }
            // console.log("PASO", data, id)
            setResponse(id ? data : data)
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setIsLoading(false)
        }

    }, [])

    const changeStatus = async (publicationId, payload) => {
        // console.log(payload)
        const data = await setStatusPublication(publicationId, payload)
        return data
    }

    const confirmPay = async (publicationId) => {
        // console.log(payload)
        const data = await setConfirmPay(publicationId)
        return data
    }

    const save = async (payload, onSuccess, editId = null) => {

        setError(null)
        setIsLoading(true)
        try {
            const data = await storePublication(payload, editId)

            if (data.error) {
                setError(data.data[0])
            } else {
                // fetch()
                onSuccess(data)
            }

            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setIsLoading(false)
        }

    }

    const store = (payload, onSuccess, editId = null) => {
        save(payload, onSuccess, editId)
    }

    const fetchLocationsByAccount = async (userId) => {

        const data = await getLocationsAccount(userId)
        return data
    }

    const getPostulateds = async (id = null, limit = 10, stats = false) => {
        let data;
        setIsLoading(true)

        if (stats) {
            return data = await getPostulatedsAll(100000000)
        }

        if (id) {
            data = await getPostulationsByPublication(id)
        } else {
            data = await getPostulatedsAll(limit)
        }
        setResponse(data)
        setIsLoading(false)
    }

    const getPostulatedsCount = useCallback(async (from = null, to = null) => {
        setIsLoading(true)

        let query = ''

        if (from) {
            query = `from=${from}`
        }

        if (to) {
            query += `${from && '&'}to=${to}`
        }

        const data = await getDataPostulatedsCount(query)
        // console.log("ACA ", data)
        setIsLoading(false)
        return data
        // setResponse(data)
    }, [])



    return { response, isLoading, error, getPostulateds, fetchData, changeStatus, confirmPay, store, fetchLocationsByAccount, getPostulatedsCount }
}


export default usePublications
